import { Flex } from "antd";
import { useTranslation } from "react-i18next";

import BaseModal from "@/components_v2/Modal/BaseModal";
import BaseButton from "@/components_v2/Button/BaseButton";
import DataBlocksTable from "@/views/datablocks/core/components/DataBlocksTable";
import { EvidenceNotificationModalProps } from "@/views/survey-views/types";

const EvidenceNotificationModal = ({
  open,
  setOpen,
  evidenceIds,
  handleConfirm,
}: EvidenceNotificationModalProps) => {
  const { t } = useTranslation();

  return (
    <BaseModal
      title={t("surveyViews.labels.confirmUsageOfEvidence")}
      open={open}
      width={900}
      onCancel={() => setOpen(false)}
      footer={
        <Flex wrap justify="space-between" align="center" gap={"small"}>
          <BaseButton
            variant="tertiary"
            key="cancel"
            onClick={() => setOpen(false)}
          >
            {t("buttons.cancel")}
          </BaseButton>

          <BaseButton variant="primary" key="confirm" onClick={handleConfirm}>
            {t("buttons.confirm")}
          </BaseButton>
        </Flex>
      }
    >
      <p>{t("surveyViews.labels.confirmUsageOfEvidenceDescription")}</p>
      <DataBlocksTable
        columnNames={["title", "type", "createdBy", "sharingRights"]}
        defaultFilters={{
          ids: evidenceIds,
        }}
        pagination={{
          defaultPageSize: 5,
        }}
      />
    </BaseModal>
  );
};

export default EvidenceNotificationModal;
